import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { BackendService } from '@app/services/backend.service';
import { catchError, first } from 'rxjs/operators';
import { SnackbarService } from '@app/services/snackbar.service';
import { MortgagesListService } from '@app/services/mortgages-list.service';
import { MortgageInterface } from '@app/interfaces/mortgage.interface';

@Injectable({ providedIn: 'root' })
export class BankIdGuard {
    private readonly mortgageListService = inject(MortgagesListService);
    private readonly backendService = inject(BackendService);
    private readonly router = inject(Router);
    private readonly snackbarService = inject(SnackbarService);

    public canActivate(
        route: ActivatedRouteSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const success = route.queryParamMap.get('success') === 'true';
        if (success) {
            this.snackbarService.showSuccess('Identita byla úspěšně ověřena pomocí BankID', 10000);
        } else {
            this.snackbarService.showError(
                'Bohužel, při ověřování identity se něco pokazilo. Prosíme zkuste proces opakovat',
                10000
            );
        }
        let latestMortgageId;
        if (this.backendService.lsIsAvailable && localStorage.getItem('latestMortgageId')) {
            latestMortgageId = localStorage.getItem('latestMortgageId');
            localStorage.removeItem('latestMortgageId');
            return this.router.createUrlTree(['/page/bankid', latestMortgageId], {
                queryParams: route.queryParams,
            });
        } else {
            return new Promise((resolve, reject) => {
                this.mortgageListService.itemsObservable
                    .pipe(
                        first((deals) => deals?.length >= 1),
                        catchError((error) => {
                            reject(error);
                            return error;
                        })
                    )
                    .subscribe((mortgages: MortgageInterface[]) => {
                        const [latestMortgage] = mortgages
                            .sort((a, b) => +new Date(a.createdAt) - +new Date(b.createdAt))
                            .slice(-1);
                        latestMortgageId = latestMortgage._id;
                        resolve(
                            this.router.createUrlTree(['/page/bankid', latestMortgageId], {
                                queryParams: route.queryParams,
                            })
                        );
                    });
            });
        }
    }
}
